import React from "react";

const MobileLogoutButton = props => {
  return (
    <button
      className="btn btn-info btn-lg"
      value={"logout"}
      onClick={() => {
        props.onClick();
      }}
    >
      {props.title.text}
    </button>
  );
};

export default MobileLogoutButton;
